import React from 'react';
import { View, Text, Animated } from 'react-native';
import { usePopup } from '../contexts/PopupContext';
import { colors, spacing, borderRadius, typography, shadows } from '../styles/theme';
import { ConfirmationDialog } from './ConfirmationDialog';

export function Popup() {
  const { popup } = usePopup();

  const getBackgroundColor = () => {
    switch (popup.type) {
      case 'success':
        return colors.success;
      case 'error':
        return colors.error;
      case 'warning':
        return colors.warning;
      default:
        return colors.accent;
    }
  };

  return (
    <>
      <ConfirmationDialog />
      {popup.visible && (
    <View
      style={{
        position: 'fixed',
        bottom: spacing.xl,
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: getBackgroundColor(),
        padding: spacing.md,
        borderRadius: borderRadius.md,
        minWidth: 300,
        maxWidth: '90%',
        zIndex: 9999,
        boxShadow: shadows.popup,
        animation: 'slideUp 0.3s ease-out',
      }}
    >
      <Text
        style={{
          color: colors.textPrimary,
          fontFamily: typography.primaryFont,
          fontSize: 16,
          textAlign: 'center',
          textShadow: shadows.text,
        }}
      >
        {popup.message}
      </Text>
    </View>
      )}
    </>
  );
} 